import BaseService from '@src/services/BaseService'

class FilesService extends BaseService {
    constructor() {
        super('files')
    }

    upload(file, type, thumbnail = false) {
        const formData = new FormData()

        formData.append('thumbnail', thumbnail ? '1' : '0')
        formData.append('image', file)
        formData.append('type', type)
        return this.axios.post(`${this.getUrl()}/uploadImage`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
    }

    uploadFile(file, type, thumbnail = false) {
        const formData = new FormData()

        formData.append('thumbnail', thumbnail ? '1' : '0')
        formData.append('file', file)
        formData.append('type', type)
        return this.axios.post(`${this.getUrl()}/upload-file`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
    }
}

export default new FilesService()
